import { Search, MonitorSmartphone, MousePointerClick, ChartLine, Mail, MessageSquare } from "lucide-react";
const servicesData = [{
  title: "MMORPG Power Leveling [PRO]",
  description: "High-speed leveling services for top RPG titles. 100% safe and secure. Starting from: $10",
  icon: Search
}, {
  title: "Account Marketplace",
  description: "Trusted game account marketplace with diverse options from fresh starts to full skins. Secure middleman service. Starting from: $25",
  icon: MonitorSmartphone
}, {
  title: "Rank Boosting",
  description: "Pro players ready to help you reach your desired rank in MOBA & FPS. High win rate guaranteed. Starting from: $5/tier",
  icon: MousePointerClick
}, {
  title: "Skill Coaching",
  description: "1-1 sessions with professional players to improve tactical thinking and mechanical skills. Starting from: $15/hour",
  icon: ChartLine
}, {
  title: "Rare Item Hunting",
  description: "Service for hunting rare gear, materials, and event items. Save your time from tedious grinding. Starting from: $8",
  icon: Mail
}, {
  title: "Discounted Game Top-up",
  description: "Providing Credits, Diamonds, and Points at rates 20% lower than direct top-ups. Fast 5-minute processing.",
  icon: MessageSquare
}];
export default function Services() {
  return;
}